import { Link } from "react-router-dom";
import { categories, siteMeta } from "@/mocks/leads";

export default function Footer() {
  return (
    <footer className="mt-auto bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-drop-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteMeta.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {siteMeta.tagline}
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line text-accent-400" aria-hidden="true" />
              {siteMeta.email}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">浏览栏目</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/leads?c=${c.id}`}
                    className="text-background-300 transition-colors hover:text-primary-300"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">参与爆料</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/guide" className="text-background-300 transition-colors hover:text-primary-300">
                  投稿流程说明
                </Link>
              </li>
              <li>
                <Link to="/guide#submit" className="text-background-300 transition-colors hover:text-primary-300">
                  在线提交线索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-primary-300">
                  内容核实原则
                </Link>
              </li>
              <li>
                <Link to="/leads" className="text-background-300 transition-colors hover:text-primary-300">
                  全部线索库
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400" aria-hidden="true" />
                {siteMeta.hotline}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-400" aria-hidden="true" />
                微信：{siteMeta.wechat}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" aria-hidden="true" />
                {siteMeta.workTime}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteMeta.name}　线索投稿与核实平台</p>
          <p>本平台所有内容均基于投稿人陈述与公开信息整理，请读者独立判断。</p>
        </div>
      </div>
    </footer>
  );
}